"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("circle", { cx: "12", cy: "12", r: "9.25", stroke: "currentColor", strokeWidth: "1.5" }),
    react_1.default.createElement("path", { d: "M14.512 11.6096L10.8123 8.64993C10.485 8.38803 10 8.62111 10 9.04037V14.9597C10 15.379 10.485 15.6121 10.8123 15.3502L14.512 12.3905C14.7622 12.1903 14.7622 11.8098 14.512 11.6096Z", fill: "currentColor" })));
